module.exports = __webpack_public_path__ + "img/moses-urbano@1x.6175b827.jpg";